import { Action, Dispatch } from "redux";
import { ThunkAction } from "redux-thunk";

import { Credentials } from "auth";
import { State } from "redux/state";

import { getString } from "utils/Utils";

export type DeleteApp = "DELETE_APP";
export const DELETE_APP: DeleteApp = "DELETE_APP";
export type DeleteAppEnd = "DELETE_APP_END";
export const DELETE_APP_END: DeleteAppEnd = "DELETE_APP_END";

export interface DeleteAppAction extends Action {
    type: DeleteApp;
    payload: {
        appId: string;
        credentials: Credentials;
    };
}

export function deleteApp(appId: string | { appId: string }): ThunkAction<any, State, undefined, DeleteAppAction> {
    return (dispatch: Dispatch<DeleteAppAction>, getState) => {
        const credentials = getState().auth.credentials;
        dispatch(deleteAppWithCredentials(appId, credentials));
    };
}

function deleteAppWithCredentials(appId: string | { appId: string }, credentials: Credentials): DeleteAppAction {
    return {
        payload: {
            appId: getString(appId, "appId"),
            credentials
        },
        type: DELETE_APP
    };
}

export interface DeleteAppEndAction extends Action {
    type: DeleteAppEnd;
    payload: {
        appId: string;
        error?: Error;
    };
}

export function deleteAppEnd(error: Error, appId: string): DeleteAppEndAction {
    return {
        payload: {
            appId,
            error
        },
        type: DELETE_APP_END
    };
}
